import React from "react";

export default function ClockMark({ chart, seconds, markType }) {
    if (!chart.current || seconds === 0) {
        return null;
    }

    const rotation = (((seconds / 3600) * 360 + 360) % 360) + 180;
    const radians = (rotation * Math.PI) / 180;

    const top = chart.current.height / 2 + 25 + ((chart.current.chartArea.height - 35) / 2) * Math.cos(radians);
    const left = chart.current.width / 2 - ((chart.current.chartArea.height - 35) / 2) * Math.sin(radians);

    const styles = {
        top: `${top}px`,
        left: `${left}px`,
        transform: `rotate(${rotation}deg)`,
    };

    return <div style={styles} className={`clock-mark ${markType}`}></div>;
}
